import { pathOr } from "ramda"
import { LABELS, OBJECT_META } from "../constants"

export const monthlyIncomeSchema = (data: any) => {
    const incomeType = pathOr('', [OBJECT_META, LABELS, 'source_income'], data)
    return {
        "type_meta": {
            "kind": "MonthlyIncome",
            "api_version": "v1"
        },
        "wages": {
            "date": "",
            "net": "",
            "gross": "",
            "net_deductions": ""
        },
        "depository": {
            "address": {
                "city": "",
                "country": "",
                "state": "",
                "street": "",
                "unit_number": "",
                "unit_type": "",
                "zip_code": ""
            },
            "attn": "",
            "email": "",
            "fax": "",
            "name": "",
            "phone_number": ""
        },
        "deductions": {
            "medicare": "",
            "social_security": "",
            "federal": "",
            "state": ""
        },
        "status": {
            "conditions": [],
            "message": "",
            "phase": "",
            "reason": ""
        },
        "multiplier": "",
        "employment_income_indicator": "",
        "income_type": incomeType,
        "income_type_other_description": "",
        "object_meta": {
            "annotations": {}
        },
        "metadata": {
            "other_income_descriptions": ""
        }
    }
}